import React from "react";

function Requirement({ valid, text, children }) {
  return (
    <p className={valid ? "valid" : "invalid"}>
      <span className={`checkmark ${valid ? "valid" : "invalid"}`}>
        {valid ? "✔" : "✖"}
      </span>
      {"    "}
      {/* If children exist, render them, otherwise fallback to text */}
      {children || text}
    </p>
  );
}

export default function PasswordRequirements({ validation }) {
  return (
    <div className="sp-form-password-requirement">
      {/* Dangerous characters */}
      <Requirement valid={validation.isSafe}>
        Must not contain dangerous characters like{" "}
        <span className="text-red-500 font-semibold">
          ( <b>"</b> ), ( <b>'</b> ), ( <b>;</b> ), ( <b>%</b> ), ( <b>\</b> ),
          (<b>--</b> ), ( <b>*</b> )
        </span>
      </Requirement>

      {/* Uppercase */}
      <Requirement valid={validation.hasUppercase}>
        Must contain at least one{" "}
        <span className="text-blue-600 font-semibold">
          uppercase letter (A–Z)
        </span>
      </Requirement>

      {/* Lowercase */}
      <Requirement valid={validation.hasLowercase}>
        Must contain at least one{" "}
        <span className="text-green-600 font-semibold">
          lowercase letter (a–z)
        </span>
      </Requirement>

      {/* Number */}
      <Requirement valid={validation.hasNumber}>
        Must contain at least one{" "}
        <span className="text-orange-500 font-semibold">number (0–9)</span>
      </Requirement>

      {/* Special character */}
      <Requirement valid={validation.hasSpecialChar}>
        Must contain at least one{" "}
        <span className="text-purple-600 font-semibold">
          special character (e.g., ! @ # $ % ^ & *)
        </span>
      </Requirement>

      {/* Minimum length */}
      <Requirement valid={validation.hasMinLength}>
        Must be at least{" "}
        <span className="text-teal-600 font-semibold">12 characters long</span>
      </Requirement>
    </div>
  );
}
